import NProgress from 'nprogress'
import React, { useEffect, useContext } from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import { apiContext } from 'services/ApiContext'
import MainLayout from './Main'
import PublicLayout from './Public'
import ModellingLayout from './Modelling'
import Management from './Management'

const Layouts = {
  management: Management,
  modelling: ModellingLayout,
  public: PublicLayout,
  main: MainLayout,
}

const IndexLayout = ({ children }) => {
  const location = useLocation()
  const { loadingType, project } = useContext(apiContext)
  const { pathname, search } = location
  const currentPath = pathname + search

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    NProgress.start()
  }, [currentPath])

  useEffect(() => {
    // NProgress Management
    switch (loadingType) {
      case 'AUTHENTICATE':
        NProgress.set(0.3)
        break
      case 'FETCH_TOKEN':
        NProgress.set(0.7)
        break
      case 'ADD_USER':
        NProgress.set(0.8)
        break
      case 'FETCH_PROJECT':
        NProgress.set(0.8)
        break
      case 'FETCH PROJECTS':
        NProgress.set(0.9)
        break
      case 'DONE':
      default:
        NProgress.done()
    }
  }, [loadingType, currentPath])

  // Layout Rendering
  const getLayout = () => {
    if (
      [
        '/signup-successful',
        '/guide',
        '/billing-success',
        '/edit',
        '/modelling-edit',
        '/new-round',
        '/employee-dashboard',
      ].includes(pathname)
    ) {
      return 'public'
    }
    if (['/portfolio', '/group'].includes(pathname)) {
      return 'management'
    }
    return 'main'
  }

  const Container = Layouts[getLayout()]

  const BootstrappedLayout = () => {
    // render previously set layout
    return <Container project={project}>{children}</Container>
  }

  return (
    <>
      <Helmet titleTemplate="Ventury Analytics - %s" />
      {BootstrappedLayout()}
    </>
  )
}

export default IndexLayout
